import {
  FaceTecSDKInstance,
  FaceTecSessionRequestProcessor,
} from "facetec-sdk";
import { useEffect, useRef } from "react";

// Starts a session on the instance; the caller picks which one by calling
// the corresponding SDK method on the instance.
export type StartSessionFn = (
  instance: FaceTecSDKInstance,
  processor: FaceTecSessionRequestProcessor,
) => void;

// Start a session once per instance; a new instance starts over,
// as a remount would.
const useStartSession = (
  instance: FaceTecSDKInstance,
  processor: FaceTecSessionRequestProcessor,
  start: StartSessionFn,
) => {
  const startedForRef = useRef<FaceTecSDKInstance | null>(null);

  useEffect(() => {
    if (startedForRef.current === instance) return;
    startedForRef.current = instance;

    // Starting a session immediately displays the capture UI.
    start(instance, processor);
  }, [instance, processor, start]);
};

export default useStartSession;
